export const FETCH_SUCCESS = 'SETTINGS/GENERAL/FETCH_REQUEST_SUCCESS';

export const PUT_SUCCESS = 'SETTINGS/GENERAL/PUT_REQUEST_SUCCESS';

export const POST_SUCCESS = 'SETTINGS/GENERAL/POST_REQUEST_SUCCESS';
